var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-time-container"},[_c('img',{staticClass:"l-clock",attrs:{"src":require("./images/clock.png"),"alt":""}}),_c('div',{staticClass:"l-time"},[_vm._v(" "+_vm._s(_vm.time)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }